import type { ElementType, HTMLAttributes, ReactNode } from 'react';

// Wrapper card con angolo ambra in alto a destra (clip-path 14×14).
// Usato per KPI card, CTA visivi, elementi di accento.

export interface DogEarCardProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  children?: ReactNode;
  /** Disattiva l'angolo ambra (per varianti senza decoro) */
  noEar?: boolean;
}

export function DogEarCard({
  as: Tag = 'div',
  children,
  noEar = false,
  className,
  ...rest
}: DogEarCardProps) {
  const cls = [
    'relative bg-[var(--paper)] text-[var(--ink)] border border-[var(--line)]',
    noEar ? '' : 'audiq-dog-ear',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={cls} {...rest}>
      {children}
    </Tag>
  );
}
